import { css } from '@emotion/css';

import {
  AlignItems,
  BaseStyle,
  Color,
  Display,
  FlexDirection,
  Font,
  Image,
  JustifyContent,
  Spacing,
  TextAlign,
} from '../../styles';

export const categorySelector = css`
  color: #4a86bd;
  text-decoration: none;
  height: 3.75rem;
  width: 30%;
  ${Display.flex}
  ${JustifyContent.center}
  ${AlignItems.center}
  ${Spacing.mb32}
  border: 0.0625rem solid #4d88be;
  border-radius: 0.125rem;
  box-shadow: 0 0.125rem 0.25rem 0 rgba(2, 85, 163, 0.15);
  background-color: #fff;
  ${Font.lg}
  ${TextAlign.center}
  @media (max-width: 48rem) {
    width: 48%;
  }
  @media (max-width: 31.25rem) {
    width: 100%;
  }
  &:hover {
    box-shadow: 0 0.25rem 0.75rem 0 rgba(2, 85, 163, 0.2);
  }
`;

export const Home = css`
  ${Display.flex}
  ${FlexDirection.column}
  ${AlignItems.center}
`;

export const levelingSection = css`
  width: 100%;
  ${Spacing.pt160}
  ${Spacing.pb160}
  background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${Image.HomeBackground});
  background-position-x: center;
  background-position-y: bottom;
  background-repeat: no-repeat;
  background-size: cover;
  ${Display.flex}
  ${JustifyContent.center}
  @media (min-width: 90.5rem) {
    background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${Image.HomeBackgroundWide});
    background-position-x: center;
    background-position-y: bottom;
    background-repeat: no-repeat;
    background-size: cover;
  }
  @media (max-width: 43.75rem) {
    ${Spacing.pt96}
    ${Spacing.pb256}
  }
`;

export const howItWorksSectionMobile = css`
  width: 100%;
  ${Display.flex}
  ${JustifyContent.center}
  ${Spacing.pt48}
  ${Spacing.pb0}
`;

export const howItWorksSection = css`
  width: 100%;
  ${Display.flex}
  ${JustifyContent.center}
  ${Spacing.pt60}
  ${Spacing.pb80}
`;

export const centeredSectionContainer = css`
  width: 100%;
  max-width: 62rem;
  ${Display.flex}
  ${FlexDirection.column}
  ${AlignItems.center}
`;

export const sectionContainer = css`
  width: 100%;
  max-width: 75rem;
`;

export const levelingCTABox = css`
  color: #fff;
  max-width: 32.75rem;
  ${Spacing.ml128}
  @media (min-width: 90.5rem) {
    ${Spacing.ml48}
  }
  @media (max-width: 51.875rem) {
    ${Spacing.ml48}
  }
  @media (max-width: 43.75rem) {
    width: 100%;
    max-width: 100%;
    ${Display.flex}
    ${FlexDirection.column}
    ${AlignItems.center}
    ${Spacing.ml0}
  }
`;

export const levelingTitle = css`
  letter-spacing: 0.04375rem;
  && {
    ${Spacing.mb20}
  }
  @media (min-width: 22.5rem) {
    && {
      ${Font.h5}
    }
  }
`;

export const levelingSubtitle = css`
  max-width: 18rem;
  ${Spacing.mb32}
  letter-spacing: 0.04375rem;
  line-height: normal;
`;

export const howItWorksTitle = css`
  letter-spacing: 0.04375rem;
  && {
    ${Spacing.mb32}
  }
  @media (max-width: 48rem) {
    && {
      ${Font.h3}
    }
  }
`;

export const videoContainer = css`
  flex: 3;
  ${Display.flex}
  ${JustifyContent.center}
  ${Spacing.my12}
  ${Spacing.mx0}

  @media (max-width: 56.1875rem) {
    width: 100%;
  }

  @media (max-width: 48rem) {
    ${Spacing.my40}
    ${Spacing.mx0}
  }

  @media (max-width: 43.75rem) {
    ${Spacing.py0}
    ${Spacing.px20}
  }
`;

export const videoSizeControl = css`
  max-width: 40rem;
  width: 100%;
  ${BaseStyle.relative}
  padding-top: 45%;

  @media (max-width: 58.75rem) {
    padding-top: 50%;
  }

  @media (max-width: 48rem) {
    padding-top: 40%;
  }

  @media (max-width: 30rem) {
    max-width: 18.75rem;
    padding-top: 46.25%;
  }

  @media (min-width: 22.5rem) {
    padding-top: 56.25%;
  }
`;

export const aboutVideo = css`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
`;

export const howItWorks = css`
  width: 100%;
`;

export const howItWorksBlock = css`
  width: 100%;
  ${Display.flex}
  ${JustifyContent.spaceBetween}
  ${AlignItems.center}
  ${Spacing.px128}
  ${Font.h5}
  letter-spacing: 0.04375rem;
  @media (max-width: 29.375rem) {
    ${Spacing.px16}
  }
`;

export const descBlock = css`
  ${Display.flex}
  ${AlignItems.center}
`;

export const descText = css`
  max-width: 21.875rem;
  && {
    ${Spacing.pr32}
  }
  @media (max-width: 48rem) {
    && {
      ${Font.lg}
      font-weight: 500;
    }
  }
  @media (max-width: 29.375rem) {
    && {
      ${Font.h6}
    }
  }
`;

export const descNum = css`
  width: 5rem;
  height: 5rem;
  min-width: 5rem;
  ${Display.flex}
  ${JustifyContent.center}
  ${AlignItems.center}
  ${Spacing.mr40}
  ${Spacing.pl4}
  ${Spacing.pb4}
  background-color: #c2d6e9;
  border-radius: 2.5rem;
  ${Font.h1}
  font-weight: 600;
  color: #fff;
  @media (max-width: 48rem) {
    width: 3.125rem;
    height: 3.125rem;
    min-width: 3.125rem;
    border-radius: 1.5625rem;
    ${Font.h3}
  }
  @media (max-width: 29.375rem) {
    width: 3.75rem;
    height: 3.75rem;
    min-width: 3.75rem;
    border-radius: 1.875rem;
    ${Font.h2}
  }
`;

export const howItWorksImage = css`
  width: 11.25rem;
  height: 11.25rem;
  @media (max-width: 48rem) {
    width: 8.125rem;
    height: 8.125rem;
  }
`;

export const getStartedHome = css`
  width: 100%;
  max-width: 75rem;
  ${Display.flex}
  ${JustifyContent.spaceAround}
  ${AlignItems.center}
  ${Spacing.pt48}
  ${Spacing.pb48}
  border-top: 0.0625rem solid #c2d6e9;
  @media (max-width: 56.1875rem) {
    ${FlexDirection.column}
    ${Spacing.pt32}
  }
`;

export const getStartedCol = css`
  ${Display.flex}
  ${FlexDirection.column}
  ${AlignItems.center}
  flex: 1;
`;

export const getStartedBorderLeft = css`
  border-left: 0.0625rem solid #c2d6e9;
`;

export const handheldImage = css`
  width: 25rem;
`;

export const getStartedTitleHome = css`
  && {
    ${Spacing.mb32}
  }
  @media (max-width: 56.1875rem) {
    && {
      margin-bottom: 0 !important;
    }
  }
  @media (max-width: 43.75rem) {
    && {
      ${Spacing.mb20}
    }
  }
`;

export const getStartedText = css`
  ${Spacing.mt32}
  ${Spacing.mb40}
  width: 100%;
  ${FlexDirection.column}
  @media (max-width: 56.1875rem) {
    ${Spacing.mt32}
    ${Spacing.mb40}
    width: 100%;
    max-width: 40rem;
    ${FlexDirection.row}
    ${JustifyContent.spaceAround}
  }
`;

export const howItWorksMobile = css`
  width: 100%;
  ${BaseStyle.relative}
  ${Spacing.pt0}
  ${Spacing.px20}
  ${Spacing.pb20}
`;

export const blueLine = css`
  width: 0.25rem;
  height: 100%;
  background-color: #cadcec;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
`;

export const blueLineTop = css`
  top: -0.125rem;
  right: 0.1875rem;
  width: 0.625rem;
  height: 0.625rem;
  ${BaseStyle.relative}
  border-radius: 0.3125rem;
  background-color: #cadcec;
`;

export const mobileRow = css`
  ${Display.flex}
  ${Spacing.mb32}
`;

export const setupDescriptionSection = css`
  flex: 1;
  ${Display.flex}
  ${FlexDirection.column}
  ${AlignItems.flexEnd}
  ${Font.sm}
  ${JustifyContent.center}
  @media (min-width: 25rem) {
  }
`;

export const setupImageBoxMobile = css`
  flex: 1;
  ${TextAlign.center}
  @media (min-width: 22.5rem) {
    ${TextAlign.left}
  }
`;

export const investImageBoxMobile = css`
  flex: 1;
  ${TextAlign.center}
  @media (min-width: 22.5rem) {
    ${TextAlign.left}
  }
`;

export const browseImageBoxMobile = css`
  flex: 1;
  ${TextAlign.center}
  @media (min-width: 22.5rem) {
    ${TextAlign.right}
  }
`;

export const howImage = css`
  width: 5.625rem;
  @media (min-width: 25rem) {
    width: 6.875rem;
  }
`;

export const stepNumberMobile = css`
  width: 1.625rem;
  height: 1.625rem;
  ${Display.flex}
  ${JustifyContent.center}
  ${AlignItems.center}
  background-color: #cadcec;
  border-radius: 0.8125rem;
  color: #fff;
  ${Font.h6}
  font-weight: 600;
`;

export const middleSplit = css`
  width: 2.5rem;
  @media (min-width: 26.875rem) {
    width: 5rem;
  }
  @media (min-width: 22.5rem) {
    width: 3.75rem;
  }
`;

export const setupText = css`
  && {
    ${Spacing.mt16}
  }
`;

export const browseDescriptionSection = css`
  flex: 1;
  ${Display.flex}
  ${FlexDirection.column}
  ${AlignItems.flexStart}
  ${Font.sm}
  ${JustifyContent.center}
  @media (min-width: 25rem) {
  }
`;

export const investDescriptionSection = css`
  flex: 1;
  ${Display.flex}
  ${FlexDirection.column}
  ${AlignItems.flexEnd}
  ${Font.sm}
  ${JustifyContent.center}
  @media (min-width: 25rem) 
  }
`;

export const browseText = css`
  && {
    ${Spacing.mt16}
  }
`;

export const signupBtn = css`
  width: 17.5rem;
  height: 3.125rem;
  ${Display.flex}
  ${JustifyContent.center}
  ${AlignItems.center}
  background-color: #0255a3;
  color: #fff;
  ${Font.h5}
  font-weight: 600;
  border-radius: 1.5625rem;
  border: 0.0625rem solid #0255a3;
  text-decoration: none;
  @media (min-width: 29.375rem) {
    width: 16.25rem;
  }
  &:hover {
    background-color: #fff;
    color: #0255a3;
  }
`;

export const investText = css`
  && {
    ${Spacing.mt16}
  }
`;

export const banner = css`
  background-color: ${Color.Brand2};
`;
